// =====================================
//
//   CMS 
//   Author: Gray
//   createtime: 2016 / 11 / 07
//
// =====================================
window.InifECMobileApp.controller("CMSProjectListController", ['$scope', '$stateParams', '$rootScope', 'CMSService', '$WebTitle',
    function($scope, $stateParams, $rootScope, CMSService, $WebTitle) {

        // --------------------------------
        // 取得更多設計案例列表
        // --------------------------------
        var loadMoreList = function() {

            if($scope.isLoading || $scope.isEmpty || $scope.isNoMore) {
                return;
            }

            getProjectList();
        }

        // --------------------------------
        // [privete] 取得設計案例總數
        // --------------------------------
        var getProjectPostCount = function() {
            
            // CMSService.getProjectPostCount().then(function(result) {

            //     $scope.projectPostCount = result;
            // })
        }

        // --------------------------------
        // [privete] 取得設計分類列表
        // --------------------------------
        var getDesignCategoryList = function() {

            CMSService.getDesignCategoryList().then(function(result) {

                if(Array.isArray(result) && result.length > 0) {
                    $scope.categoryList = result;
                }
            })
        }

        // --------------------------------
        // [privete] 取得設計案例列表
        // --------------------------------
        var getProjectList = function() {

            if($scope.isLoading) {
                return;
            }

            // 切換state時，infinit scroll 會立刻做事，這段是防止在某個分類下會拿到全部未分類的資料
            if($scope.category && (!$scope.categoryItem || $scope.categoryItem.key != $scope.category)) {
                return;
            }

            var id = $scope.categoryItem ? $scope.categoryItem._id : undefined;
            $scope.isLoading = true;

            CMSService.getProjectList(id, $scope.sort, $scope.page).then(function(result) {

                if(result) {
                    if(Array.isArray(result.results) && result.results.length > 0) {
                        Array.prototype.push.apply($scope.projectList, result.results);
                    } else if($scope.projectList.length > 0) {
                        $scope.isNoMore = true;
                    } else if($scope.projectList.length == 0) {
                        $scope.isEmpty = true;
                    }
                } else {
                    $scope.isError = true;
                }

                $scope.page++;
                $scope.isLoading = false;

            }, function(error) {

                $scope.isLoading = false;
                $scope.isError = true;
            })
        }

        // --------------------------------
        // [privete] 取得設計分類資訊
        // --------------------------------
        var getDesignCategory = function() {

            if($scope.category) {
                CMSService.getDesignCategory($scope.category).then(function(result) {

                    if(result) {
                        $scope.categoryItem = result;

                        getProjectList();
                    }
                })
            } else {
                getProjectList();
            }

            $WebTitle.setWebTitle('設計案例 | inif印衣服，巧昱服飾設計有限公司');
        }

        var toggleLabelMenuBar = function() {

            $scope.isShowSortMenu = false;
            $scope.isShowCategoryMenu = false;
            $scope.isShowLabelMenu = !$scope.isShowLabelMenu;
        }

        var toggleCategoryMenuBar = function() {

            $scope.isShowLabelMenu = false;
            $scope.isShowSortMenu = false;
            $scope.isShowCategoryMenu = !$scope.isShowCategoryMenu;
        }

        var toggleSortMenuBar = function() {

            $scope.isShowLabelMenu = false;
            $scope.isShowCategoryMenu = false;
            $scope.isShowSortMenu = !$scope.isShowSortMenu;
        }

        // --------------------------------
        // [private] 初始化
        // --------------------------------
        var init = function() {
            $scope.page = 1;
            getDesignCategory();
            getDesignCategoryList();
            getProjectPostCount();
        }

        //==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================
        $scope.page = 1;
        $scope.sort = $stateParams.sort || 'time';
        $scope.category = $stateParams.category;
        $scope.categoryItem;

        $scope.categoryList = [];
        $scope.projectList = [];
        $scope.isLoading = false;
        $scope.isNoMore = false;
        $scope.isEmpty = false;
        $scope.isError = false;
        $scope.projectPostCount = 0;
        $scope.isShowLabelMenu = false;
        $scope.isShowCategoryMenu = false;
        $scope.isShowSortMenu = false;

        //==========================
        //  Methods
        //==========================
        $scope.loadMoreList = loadMoreList;
        $scope.toggleLabelMenuBar = toggleLabelMenuBar;
        $scope.toggleCategoryMenuBar = toggleCategoryMenuBar;
        $scope.toggleSortMenuBar = toggleSortMenuBar;

        //==========================
        //  Init
        //==========================
        init();
    }
]);